module.exports = __webpack_public_path__ + "bc46feb6bf2a75445656a2232b10a2bb.jpg";